// extracted by mini-css-extract-plugin
module.exports = {"areasOfInterest":"styles-module--areasOfInterest--3O_Bq","title":"styles-module--title--V-sQp","subtitle":"styles-module--subtitle--IggIm"};